import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

// import AvailableGames from "../Components/Games/AvailableGames";
import LoadingSkeletons from "../Components/UI/LoadingSkeletons";
import { useGames } from "../Hooks/useGetGames";
import FilteredGames from "../Components/Games/FilteredGames";
import { useMediaQuery } from "@chakra-ui/react";
import GameBannerAd from "../Components/Advertisement/GameBannerAd";
// import LandscapeAd from "../Components/Advertisement/LandscapeAd";

function AllGames() {
  ReactGA.send({
    hitType: "pageview",
    page: "/games",
    title: "All Games",
  });
  
  const { data, isLoading } = useGames();
  const [isLargerThan1580] = useMediaQuery("(min-width: 1580px)")
  if (isLoading) return <LoadingSkeletons />;
  const singlePlayer = data.games.filter(
    (item) => !item.description.includes("Multiplayer")
  );

  const multiPlayer = data.games.filter((item) =>
    item.description.includes("Multiplayer")
  );

 

  return (
    <>
      <Helmet>
        <title>All Games | Leaderbored</title>
        <link rel='canonical' href='https://www.leaderbored.gg/all-games' />
      </Helmet>
      {/* <LandscapeAd /> */}
      {/* <AvailableGames minW='190px' games={data.games} /> */}
      <FilteredGames heading={"Single player"} games={singlePlayer} isPC={isLargerThan1580} />
      <GameBannerAd />
      <FilteredGames heading={"Multiplayer"} games={multiPlayer} isPC={isLargerThan1580} />
    </>
  );
}

export default AllGames;
